import React from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";
import styles from './PortfolioBlock.module.scss';
import classNames from 'classnames';

function PortfolioBlock(props) {
    const {image, live, source, title, darkMode} = props;

    return (
        <Box className={styles.portfolioBlock}>
            <Box className={styles.imageContainer}>
                <Box component={'img'} src={image} alt={title}/>
            </Box>
            <h1 
                className={styles.projectTitle}
                style={{ color: darkMode ? '#f5f5f5' : '#1a1a1a' }}
            >
                {title}
            </h1>
            <Box className={styles.linksContainer}>
                <Box className={classNames(styles.linkBox, darkMode ? styles.dark : styles.light)}>
                    <IconLink link={live} title={'Live Demo'} icon={'fa fa-external-link'}/>
                </Box>
                {source && (
                    <Box className={classNames(styles.linkBox, darkMode ? styles.dark : styles.light)}>
                        <IconLink link={source} title={'Source Code'} icon={'fa fa-code'}/>
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default PortfolioBlock;